

































































































































import { useFilters } from '@/app/composable';
import {
    BanIcon,
    CheckCircleIcon,
    ClockIcon,
    HashtagIcon,
    MinusCircleIcon,
    XCircleIcon,
} from '@vue-hero-icons/outline';
import { computed, defineComponent, PropType } from '@vue/composition-api';
import { ExecutionMetrics, ExecutionStreamingMetrics } from '../../types';

export default defineComponent({
    name: 'ExecutionHistoryStatistics',
    components: {
        HashtagIcon,
        CheckCircleIcon,
        XCircleIcon,
        ClockIcon,
        BanIcon,
        MinusCircleIcon,
    },
    props: {
        executionMetrics: {
            type: Object as PropType<ExecutionMetrics | ExecutionStreamingMetrics>,
        },
        isLongRunning: {
            type: Boolean,
            default: false,
        },
    },
    setup(props) {
        const { formatCount, formatSeconds } = useFilters();

        const metrics = computed(() => {
            if (props.isLongRunning) {
                const streamingMetrics = props.executionMetrics as ExecutionStreamingMetrics;
                return {
                    total: {
                        label: 'Total Messages',
                        value: formatCount(streamingMetrics.totalMessages),
                    },
                    successful: {
                        label: 'Processed Messages',
                        value: formatCount(streamingMetrics.processedMessages),
                    },
                    failed: { label: 'Skipped Messages', value: formatCount(streamingMetrics.skippedMessages) },
                    time: { label: 'Execution Time', ...formatSeconds(streamingMetrics.executionTime) },
                };
            }
            const normalMetrics = props.executionMetrics as ExecutionMetrics;
            return {
                total: { label: 'Total Executions', value: formatCount(normalMetrics.totalExecutions) },
                successful: {
                    label: 'Successful Executions',
                    value: formatCount(normalMetrics.successfulExecutions),
                },
                failed: { label: 'Failed Executions', value: formatCount(normalMetrics.failedExecutions) },
                cancelled: { label: 'Cancelled Executions', value: formatCount(normalMetrics.cancelledExecutions) },
                skipped: { label: 'Skipped Executions', value: formatCount(normalMetrics.skippedExecutions) },
                time: { label: 'Average Execution Time', ...formatSeconds(normalMetrics.avgExecutionTime) },
            };
        });

        return { metrics };
    },
});
